import { buildDynamicFilters } from '@/lib/dynamic-filters';
import type { FilterInput } from './types';

export const toFilters = (input: FilterInput) => {
  if (!input || Object.keys(input).length === 0) {
    return undefined;
  }

  const normalized = Object.entries(input).reduce<
    Record<string, string | number | { op: string; from: string; to: string }>
  >((acc, [field, value]) => {
    if (Array.isArray(value)) {
      if (value.length > 0) {
        acc[field] = `contains:${value.map(item => String(item).replace(/^contains:/, '')).join(';')}`;
      }
      return acc;
    }

    if (value !== undefined && value !== null && value !== '') {
      acc[field] = value;
    }

    return acc;
  }, {});

  const filters = buildDynamicFilters(normalized);
  return Object.keys(filters).length > 0 ? filters : undefined;
};
